export function SparkleDashedCircleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5416 5.17118C14.3094 5.34531 15.044 5.64767 15.712 6.06451L16.7708 4.36778C15.913 3.83246 14.97 3.44433 13.9839 3.2207L13.5416 5.17118Z"
        fill="currentColor"
      />
      <path
        d="M9.3067 5.53886C9.67672 5.38462 10.0517 5.2647 10.4283 5.1774L9.97665 3.22906C9.49189 3.34144 9.01054 3.4955 8.53718 3.69282C8.06383 3.89014 7.61557 4.12358 7.19451 4.38879L8.26045 6.08106C8.58754 5.87503 8.93668 5.6931 9.3067 5.53886Z"
        fill="currentColor"
      />
      <path
        d="M17.9189 8.26043C18.1249 8.58753 18.3069 8.93667 18.4611 9.30668C18.6154 9.6767 18.7353 10.0517 18.8226 10.4283L20.7709 9.97664C20.6585 9.49187 20.5045 9.01053 20.3072 8.53717C20.1098 8.06381 19.8764 7.61555 19.6112 7.1945L17.9189 8.26043Z"
        fill="currentColor"
      />
      <path
        d="M5.1712 10.4584C5.34533 9.69054 5.64768 8.95593 6.06452 8.28796L4.36779 7.22913C3.83247 8.08697 3.44434 9.02998 3.22072 10.0161L5.1712 10.4584Z"
        fill="currentColor"
      />
      <path
        d="M18.8288 13.5416C18.6547 14.3094 18.3523 15.044 17.9355 15.712L19.6322 16.7708C20.1675 15.913 20.5557 14.97 20.7793 13.9839L18.8288 13.5416Z"
        fill="currentColor"
      />
      <path
        d="M5.53887 14.6933C5.38463 14.3233 5.26471 13.9483 5.17742 13.5717L3.22908 14.0233C3.34145 14.5081 3.49552 14.9894 3.69284 15.4628C3.89015 15.9362 4.12359 16.3844 4.38881 16.8055L6.08108 15.7395C5.87505 15.4124 5.69311 15.0633 5.53887 14.6933Z"
        fill="currentColor"
      />
      <path
        d="M15.7395 17.9189C15.4125 18.1249 15.0633 18.3069 14.6933 18.4611C14.3233 18.6153 13.9483 18.7353 13.5717 18.8226L14.0233 20.7709C14.5081 20.6585 14.9895 20.5045 15.4628 20.3071C15.9362 20.1098 16.3844 19.8764 16.8055 19.6112L15.7395 17.9189Z"
        fill="currentColor"
      />
      <path
        d="M10.4584 18.8288C9.69056 18.6547 8.95595 18.3523 8.28798 17.9355L7.22915 19.6322C8.08698 20.1675 9.02999 20.5556 10.0161 20.7793L10.4584 18.8288Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0513 5.68375L9.70944 9.70941L5.68378 11.0513V12.9487L9.70944 14.2906L11.0513 18.3162H12.9487L14.2906 14.2906L18.3162 12.9487V11.0513L14.2906 9.70941L12.9487 5.68375H11.0513ZM11.4487 10.8162L12 9.16226L12.5513 10.8162L13.1838 11.4487L14.8377 12L13.1838 12.5513L12.5513 13.1838L12 14.8377L11.4487 13.1838L10.8162 12.5513L9.16228 12L10.8162 11.4487L11.4487 10.8162Z"
        fill="currentColor"
      />
    </svg>
  );
}
